import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PageWithTabs } from '../../components/shared/PageWithTabs/PageWithTabs';
import { NoReplyEmailTab } from './NoReplyEmailTab';
import { ScheduledEmailsTab } from './ScheduledEmailsTab';

type Props = {
  history: RouteComponentProps['history'];
};

export const PageEmailDebug: FC<Props> = ({ history }) => {
  const tabInfo = [
    {
      name: 'No Reply',
      path: '/email-debug',
      component: NoReplyEmailTab,
    },
    {
      name: 'Scheduled Emails',
      path: '/email-debug/scheduled',
      component: ScheduledEmailsTab,
    },
  ];

  return <PageWithTabs tabInfo={tabInfo} history={history} />;
};

export default PageEmailDebug;
